import KeyValuePair from '@/modules/core/support/KeyValuePair'

/**
 * Evento asociado a reserva
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
export default class Event {
    /**
     * Color asociado al evento en formato rgb
     */
    public color = ''

    /**
     * Constructor
     *
     * @param id
     * @param name
     */
    constructor (public readonly id = 0, public name = '') {}

    /**
     * Indica si la entidad es nueva y todavía no ha sido registrada
     */
    public get isNew (): boolean {
        return !this.id
    }

    public static deserialize (data: KeyValuePair) {
        return Object.assign(new this(), {
            id: data.id,
            name: data.name,
            color: data.color || '',
        })
    }

    public serialize (): KeyValuePair {
        return {
            name: this.name,
            color: this.color,
        }
    }
}
